module.exports = __webpack_public_path__ + "assets/21dfcbb3ac47a27aa02330a03c9b5d3f.png";